var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex flex-col form-content p-5" },
    [
      _c("div", { staticClass: "flex w-full mb-6" }, [
        _c(
          "div",
          { staticClass: "flex flex-col w-1/2 pr-1" },
          [
            _c(
              "form-item",
              { attrs: { label: "Search" } },
              [
                _c("Input", {
                  attrs: { placeholder: "Search specific query" },
                  model: {
                    value: _vm.filter.q,
                    callback: function($$v) {
                      _vm.$set(_vm.filter, "q", $$v)
                    },
                    expression: "filter.q"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex flex-col w-1/2 pl-1" },
          [
            _c(
              "form-item",
              { attrs: { label: "Type" } },
              [
                _c("Select", {
                  attrs: {
                    "empty-label": "All Type",
                    data: [
                      { value: "mission", label: "Mission" },
                      { value: "podcast", label: "Podcast" }
                    ]
                  },
                  model: {
                    value: _vm.filter.type,
                    callback: function($$v) {
                      _vm.$set(_vm.filter, "type", $$v)
                    },
                    expression: "filter.type"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex w-full mb-6" }, [
        _c(
          "div",
          { staticClass: "flex flex-col w-1/2 pr-1" },
          [
            _c(
              "form-item",
              { attrs: { label: "Tags" } },
              [
                _c(
                  "el-select",
                  {
                    ref: "tagSelect",
                    staticClass: "w-full",
                    attrs: {
                      multiple: "",
                      filterable: "",
                      remote: "",
                      "default-first-option": "",
                      "reserve-keyword": "",
                      size: "large",
                      placeholder: "Add a tag to filter songs",
                      "remote-method": _vm.searchTags,
                      loading: _vm.loadingTags
                    },
                    on: { change: _vm.changeTag },
                    model: {
                      value: _vm.tagsValue,
                      callback: function($$v) {
                        _vm.tagsValue = $$v
                      },
                      expression: "tagsValue"
                    }
                  },
                  _vm._l(_vm.tagsOption, function(item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value }
                    })
                  }),
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex flex-col w-1/2 pl-1" },
          [
            _c(
              "form-item",
              { attrs: { label: "Language" } },
              [
                _c(
                  "el-select",
                  {
                    ref: "langSelect",
                    staticClass: "w-full",
                    attrs: {
                      multiple: "",
                      filterable: "",
                      "default-first-option": "",
                      "reserve-keyword": "",
                      size: "large",
                      placeholder: "Add a language to filter songs"
                    },
                    on: { change: _vm.changeLang },
                    model: {
                      value: _vm.langValue,
                      callback: function($$v) {
                        _vm.langValue = $$v
                      },
                      expression: "langValue"
                    }
                  },
                  _vm._l(_vm.langOption, function(item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value }
                    })
                  }),
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex w-full mb-3" }, [
        _c(
          "button",
          {
            staticClass:
              "text-sm w-full focus:outline-none px-4 py-2 rounded font-bold cursor-pointer\n                        hover:bg-blue-100 hover:text-blue-700\n                        text-blue-100 bg-blue-700\n                          border duration-200 ease-in-out\n                        border-blue-600 transition",
            on: { click: _vm.search }
          },
          [_vm._v("Search")]
        )
      ]),
      _vm._v(" "),
      _c(
        "data-tables-server",
        {
          ref: "tableSong",
          staticClass: "song-management",
          attrs: {
            data: _vm.listVideos,
            total: _vm.totalVideos,
            "pagination-props": { background: true, pageSizes: [10] }
          },
          on: { "query-change": _vm.onChangeTable }
        },
        [
          _vm._l(_vm.tableColumn, function(column) {
            return _c("el-table-column", {
              key: column.prop,
              attrs: {
                prop: column.prop,
                label: column.label,
                sortable: "custom"
              }
            })
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Thumbnail", align: "left", width: "150px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("img", { attrs: { src: scope.row.thumbnail, alt: "" } })
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Actions", align: "right", width: "150px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass:
                          "static inline-block text-left container-action"
                      },
                      [
                        _c(
                          "VueCustomTooltip",
                          {
                            attrs: {
                              label: !scope.row.added ? "Add" : "Remove",
                              position: "is-left"
                            }
                          },
                          [
                            !scope.row.added
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "p-2 rounded bg-blue-700 text-blue-100 hover:bg-blue-100 hover:text-blue-700 border duration-200 ease-in-out\n                        border-blue-600 transition focus:outline-none",
                                    on: {
                                      click: function($event) {
                                        return _vm.addVideosTo(scope.row, true)
                                      }
                                    }
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: ["fa", "plus"] }
                                    }),
                                    _vm._v(" Add\n            ")
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.added
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "p-2 rounded bg-blue-100 text-blue-700 hover:bg-blue-700 hover:text-blue-100 border duration-200 ease-in-out\n                        border-blue-600 transition focus:outline-none",
                                    on: {
                                      click: function($event) {
                                        return _vm.addVideosTo(scope.row, false)
                                      }
                                    }
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: ["fa", "check"] }
                                    }),
                                    _vm._v(" Remove\n            ")
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dc1bf3dc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc1bf3dc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/MissionsVideos/Channel/SearchVideos.vue
// module id = null
// module chunks = 